.separator() {
  transition: 0.3s ease width;
  background-color: var(--hr-bg-color, @ig-red-600);
}

:root {
  --hr-margin: 0 auto;
  --hr-height: 4px;
  --hr-width: 200px;
  --hr-bg-color: @ig-red-600;
  --hr-height-arrow: 25px;
  --hr-width-arrow: 43px;
  --hr-height-thin: 1px;
  --hr-width-border: 100%;
  --hr-bg-color-border: @ig-grey-400;
  --hr-width-animated: 0;
}

.theme--rebrand {
  --hr-width: 1200px;
  --hr-height: 1px;
  --hr-bg-color: @ig-grey-400;
  @media (max-width: @large-breakpoint) {
    --hr-width: 100%;
  }
}

igws-hr {
  display: block;
  margin: var(--hr-margin, 0 auto);
  height: var(--hr-height, 4px);
  width: var(--hr-width, 200px);

  &.arrow {
    height: var(--hr-height-arrow, 25px);
    width: var(--hr-width-arrow, 43px);
    background: @more-info no-repeat;
  }

  &.separator {
    .separator();
  }

  &.separator-thin {
    height: var(--hr-height-thin, 1px);
    .separator();
  }

  &.separator--animated {
    width: var(--hr-width-animated, 0);
    max-width: 100%;
    .theme--rebrand & {
      @media (max-width: @large-breakpoint) {
        max-width: 80%;
      }
    }
  }

  &.border {
    height: var(--hr-height-thin, 1px);
    width: var(--hr-width-border, 100%);
    background-color: var(--hr-bg-color-border, @ig-grey-400);
  }
}
